module.exports = __webpack_public_path__ + "static/media/80.681802dd.jpg";